// Public landing page (pages/Landing.jsx).
const strings = {
  es: {
    lp_logo_sub: "Plataforma clínica",
    lp_bar: "Expediente clínico digital para clínicas y consultorios en México",
    lp_nav_features: "Funciones",
    lp_nav_team: "Para tu equipo",
    lp_nav_how: "Cómo empezar",
    lp_nav_faq: "Preguntas",
    lp_eyebrow: "Expediente clínico digital · NOM-004",
    lp_h1_a: "Menos papeleo.",
    lp_h1_b: "Más tiempo con",
    lp_h1_c: "tus pacientes.",
    lp_lead: "ClinicOS reúne expediente clínico, agenda, recetas y seguimiento de pacientes en una sola plataforma, para clínicas con varios especialistas y para consultorios independientes.",
    lp_card_clinic_eyebrow: "Clínicas",
    lp_card_clinic_title: "Administra tu clínica",
    lp_card_clinic_desc: "Médicos, asistentes, agenda y reportes",
    lp_card_doctor_eyebrow: "Médicos",
    lp_card_doctor_title: "Tu consultorio digital",
    lp_card_doctor_desc: "Expediente, recetas y citas",
    lp_have_account: "¿Ya tienes cuenta?",
    lp_badge: "Conforme a NOM-004 · CIE-10",
    lp_demo_followup: "Seguimiento",
    lp_demo_patient: "María G.",
    lp_demo_when: "Mañana · 11:00 · Dra. Ramírez",
    lp_demo_confirmed: "Confirmó por WhatsApp",
    lp_demo_today: "Hoy",
    lp_demo_appts: "citas en la agenda",
    lp_mq_1: "Expediente NOM-004",
    lp_mq_2: "Diagnósticos CIE-10",
    lp_mq_3: "Recetas en PDF",
    lp_mq_4: "Agenda por médico",
    lp_mq_5: "Confirmaciones por WhatsApp",
    lp_mq_6: "Seguimiento de pacientes",
    lp_mq_7: "Reportes y exportación a Excel",
    lp_mq_8: "Varias clínicas, una plataforma",
    lp_features_eyebrow: "Funciones",
    lp_features_h2_a: "Todo tu consultorio,",
    lp_features_h2_b: "un solo lugar.",
    lp_f_nom_title: "Expediente conforme a NOM-004",
    lp_f_nom_desc: "Historia clínica y notas de evolución con interrogatorio, exploración física, signos vitales y diagnósticos CIE-10 firmados por el médico.",
    lp_f_appts_title: "Agenda y recordatorios",
    lp_f_appts_desc: "Calendario por médico, aviso de choques de horario y recordatorios por correo con la marca de tu clínica.",
    lp_f_followup_title: "Confirmación y seguimiento",
    lp_f_followup_desc: "Lista diaria de citas por confirmar, pacientes que faltaron y seguimientos pendientes, con historial de cada llamada o mensaje.",
    lp_f_rx_title: "Recetas en PDF",
    lp_f_rx_desc: "Recetas con cédula profesional, datos del paciente y el logotipo de tu clínica, listas para imprimir o enviar.",
    lp_f_reports_title: "Reportes",
    lp_f_reports_desc: "Citas, asistencia, actividad por médico y documentación clínica, con exportación a Excel, PDF y CSV.",
    lp_f_ai_title: "Asistente de IA",
    lp_f_ai_desc: "Apoyo para redactar notas y recetas más rápido. El médico siempre revisa y decide.",
    lp_team_eyebrow: "Para tu equipo",
    lp_team_h2_a: "Cada persona ve",
    lp_team_h2_b: "lo que necesita.",
    lp_role_clinic_title: "Clínica",
    lp_role_clinic_desc: "Para quien administra la clínica.",
    lp_role_clinic_1: "Alta de médicos y asistentes",
    lp_role_clinic_2: "Agenda y pacientes de toda la clínica",
    lp_role_clinic_3: "Tu nombre y logotipo en la plataforma",
    lp_role_doctor_title: "Médico",
    lp_role_doctor_desc: "Para atender a tus pacientes.",
    lp_role_doctor_1: "Expediente clínico y notas firmadas",
    lp_role_doctor_2: "Recetas y archivos del paciente",
    lp_role_doctor_3: "Tu agenda del día",
    lp_role_assistant_title: "Asistente",
    lp_role_assistant_desc: "Para quien apoya la agenda de uno o más médicos.",
    lp_role_assistant_1: "Agenda y reagenda citas",
    lp_role_assistant_2: "Confirma por llamada o WhatsApp",
    lp_role_assistant_3: "Sin acceso al expediente clínico",
    lp_how_eyebrow: "Cómo empezar",
    lp_how_h2_a: "Listo en",
    lp_how_h2_b: "tres pasos.",
    lp_step_1_title: "Crea tu cuenta",
    lp_step_1_desc: "Registra tu clínica o tu consultorio y sube tu logotipo.",
    lp_step_2_title: "Invita a tu equipo",
    lp_step_2_desc: "Agrega médicos y asistentes; cada quien entra con su propia cuenta y permisos.",
    lp_step_3_title: "Atiende y da seguimiento",
    lp_step_3_desc: "Agenda, documenta cada consulta y confirma las próximas citas desde un solo lugar.",
    lp_faq_eyebrow: "Preguntas frecuentes",
    lp_faq_h2: "Lo que nos preguntan antes de empezar.",
    lp_faq_nom_q: "¿Cumple con la NOM-004-SSA3-2012?",
    lp_faq_nom_a: "El expediente incluye los apartados que pide la norma: ficha de identificación, interrogatorio, exploración física, diagnósticos con CIE-10, pronóstico e indicación terapéutica, con nombre y cédula del médico. Las notas firmadas no se pueden modificar.",
    lp_faq_data_q: "¿Dónde se guarda la información?",
    lp_faq_data_a: "La información viaja cifrada (HTTPS) y se guarda en una base de datos en la nube con acceso restringido. Cada clínica solo ve sus propios pacientes, y cada médico solo los suyos.",
    lp_faq_brand_q: "¿Puedo usar el nombre y logotipo de mi clínica?",
    lp_faq_brand_a: "Sí. En Configuración eliges el nombre y logotipo que verá tu equipo dentro de la plataforma; el logotipo también aparece en tus recetas.",
    lp_faq_assistant_q: "¿Las asistentes pueden ver el expediente clínico?",
    lp_faq_assistant_a: "No. Las asistentes gestionan agenda, datos de contacto y seguimiento de los médicos que tienen asignados, pero no ven notas médicas, recetas ni archivos clínicos.",
    lp_faq_start_q: "¿Cómo empiezo?",
    lp_faq_start_a: "Crea tu cuenta de clínica o de médico independiente, completa tu perfil e invita a tu equipo. Si tienes dudas, escríbenos y te ayudamos.",
    lp_cta_h2: "Empieza hoy.",
    lp_cta_sub: "Crea tu cuenta e invita a tu equipo en minutos.",
    lp_footer_desc: "Plataforma de expediente clínico, agenda y seguimiento para clínicas y consultorios en México.",
    lp_footer_platform: "Plataforma",
    lp_footer_access: "Acceso",
    lp_create_account: "Crear cuenta",
  },
  en: {
    lp_logo_sub: "Clinical platform",
    lp_bar: "Digital clinical records for clinics and practices in Mexico",
    lp_nav_features: "Features",
    lp_nav_team: "For your team",
    lp_nav_how: "Get started",
    lp_nav_faq: "FAQ",
    lp_eyebrow: "Digital clinical records · NOM-004",
    lp_h1_a: "Less paperwork.",
    lp_h1_b: "More time with",
    lp_h1_c: "your patients.",
    lp_lead: "ClinicOS brings clinical records, scheduling, prescriptions and patient follow-up into one platform, for multi-specialty clinics and independent practices.",
    lp_card_clinic_eyebrow: "Clinics",
    lp_card_clinic_title: "Run your clinic",
    lp_card_clinic_desc: "Doctors, assistants, schedule and reports",
    lp_card_doctor_eyebrow: "Doctors",
    lp_card_doctor_title: "Your digital practice",
    lp_card_doctor_desc: "Records, prescriptions and appointments",
    lp_have_account: "Already have an account?",
    lp_badge: "NOM-004 compliant · ICD-10",
    lp_demo_followup: "Follow-up",
    lp_demo_patient: "María G.",
    lp_demo_when: "Tomorrow · 11:00 · Dr. Ramírez",
    lp_demo_confirmed: "Confirmed via WhatsApp",
    lp_demo_today: "Today",
    lp_demo_appts: "appointments scheduled",
    lp_mq_1: "NOM-004 records",
    lp_mq_2: "ICD-10 diagnoses",
    lp_mq_3: "PDF prescriptions",
    lp_mq_4: "Per-doctor scheduling",
    lp_mq_5: "WhatsApp confirmations",
    lp_mq_6: "Patient follow-up",
    lp_mq_7: "Reports and Excel export",
    lp_mq_8: "Many clinics, one platform",
    lp_features_eyebrow: "Features",
    lp_features_h2_a: "Your whole practice,",
    lp_features_h2_b: "one place.",
    lp_f_nom_title: "NOM-004 clinical records",
    lp_f_nom_desc: "Clinical history and progress notes with interrogation, physical exam, vital signs and ICD-10 diagnoses signed by the doctor.",
    lp_f_appts_title: "Scheduling and reminders",
    lp_f_appts_desc: "Per-doctor calendar, double-booking warnings and email reminders branded with your clinic.",
    lp_f_followup_title: "Confirmation and follow-up",
    lp_f_followup_desc: "A daily list of appointments to confirm, no-shows and pending follow-ups, with a history of every call or message.",
    lp_f_rx_title: "PDF prescriptions",
    lp_f_rx_desc: "Prescriptions with professional license, patient details and your clinic's logo, ready to print or send.",
    lp_f_reports_title: "Reports",
    lp_f_reports_desc: "Appointments, attendance, doctor activity and clinical documentation, exportable to Excel, PDF and CSV.",
    lp_f_ai_title: "AI assistant",
    lp_f_ai_desc: "Help drafting notes and prescriptions faster. The doctor always reviews and decides.",
    lp_team_eyebrow: "For your team",
    lp_team_h2_a: "Everyone sees",
    lp_team_h2_b: "what they need.",
    lp_role_clinic_title: "Clinic",
    lp_role_clinic_desc: "For whoever runs the clinic.",
    lp_role_clinic_1: "Add doctors and assistants",
    lp_role_clinic_2: "The whole clinic's schedule and patients",
    lp_role_clinic_3: "Your name and logo on the platform",
    lp_role_doctor_title: "Doctor",
    lp_role_doctor_desc: "For seeing your patients.",
    lp_role_doctor_1: "Clinical record and signed notes",
    lp_role_doctor_2: "Prescriptions and patient files",
    lp_role_doctor_3: "Your daily agenda",
    lp_role_assistant_title: "Assistant",
    lp_role_assistant_desc: "For whoever supports one or more doctors' schedules.",
    lp_role_assistant_1: "Book and reschedule appointments",
    lp_role_assistant_2: "Confirm by call or WhatsApp",
    lp_role_assistant_3: "No access to the clinical record",
    lp_how_eyebrow: "Get started",
    lp_how_h2_a: "Ready in",
    lp_how_h2_b: "three steps.",
    lp_step_1_title: "Create your account",
    lp_step_1_desc: "Register your clinic or practice and upload your logo.",
    lp_step_2_title: "Invite your team",
    lp_step_2_desc: "Add doctors and assistants; everyone signs in with their own account and permissions.",
    lp_step_3_title: "See patients and follow up",
    lp_step_3_desc: "Schedule, document every visit and confirm upcoming appointments from one place.",
    lp_faq_eyebrow: "FAQ",
    lp_faq_h2: "What people ask before they start.",
    lp_faq_nom_q: "Does it comply with NOM-004-SSA3-2012?",
    lp_faq_nom_a: "Records include the sections the standard requires: identification, interrogation, physical exam, ICD-10 diagnoses, prognosis and treatment, with the doctor's name and license. Signed notes can't be modified.",
    lp_faq_data_q: "Where is the data stored?",
    lp_faq_data_a: "Data travels encrypted (HTTPS) and is stored in a cloud database with restricted access. Each clinic only sees its own patients, and each doctor only theirs.",
    lp_faq_brand_q: "Can I use my clinic's name and logo?",
    lp_faq_brand_a: "Yes. In Settings you choose the name and logo your team sees inside the platform; the logo also appears on your prescriptions.",
    lp_faq_assistant_q: "Can assistants see the clinical record?",
    lp_faq_assistant_a: "No. Assistants manage scheduling, contact details and follow-up for their assigned doctors, but can't see medical notes, prescriptions or clinical files.",
    lp_faq_start_q: "How do I start?",
    lp_faq_start_a: "Create a clinic or independent-doctor account, complete your profile and invite your team. If you have questions, write to us and we'll help.",
    lp_cta_h2: "Start today.",
    lp_cta_sub: "Create your account and invite your team in minutes.",
    lp_footer_desc: "Clinical records, scheduling and follow-up platform for clinics and practices in Mexico.",
    lp_footer_platform: "Platform",
    lp_footer_access: "Access",
    lp_create_account: "Create account",
  },
};

export default strings;
